import Typed from 'react-typed';

export function Header() {
    return <div className={"w-full p-4"}>
        <div className={"content-limit flex justify-center"}>
            <div className={"flex items-center gap-4 text-lg w-48 -mr-20"}>
                <img src={"/logo.png"} className={"w-10 h-10"} alt={"logo of clay"}/>

                <Typed
                    className={"text-[#9edcda]"}
                    strings={['粘土云', 'Clay Cloud']}
                    typeSpeed={160}
                    backSpeed={100}
                    startDelay={300}
                    cursorChar={'_'}
                    loop
                />
            </div>
           {/*<div className={"ml-auto flex gap-8 items-center"}>*/}
           {/*    <div>设计</div>*/}
           {/*    <div>技术</div>*/}
           {/*</div>*/}
        </div>
    </div>
}